import ReactDOM from 'react-dom';

//components
import BreadCrumbs from  '@/components/page/breadCrumbs/BreadCrumbs';



const SpotlightCarouselPortal = () => {
    const targetContainer = document.getElementById('react-breadcrumbs-portal');

    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <BreadCrumbs 
            menuId = {targetContainer?.getAttribute?.('data-menu-id') ?? undefined}
        />, 
        targetContainer
    );
};

export default SpotlightCarouselPortal;